<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  steps: {
    type: Array,
    default: () => [],
  },
  offset: {
    type: Number,
    default: 0,
  },
})

const { t } = useI18n()

const anchorTitle = computed(() => useAnchorTitle(props.title))
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8">
      <h2
        v-if="title"
        :id="anchorTitle"
        class="title scale-3"
      >
        {{ title }}
      </h2>
      <ul class="steps">
        <li
          v-for="(item, index) in steps"
          :key="index"
        >
          <div class="scale-1 item__step">
            {{ t('recipe.instructions.step') }}
            {{ index + offset + 1 }}
          </div>
          <div
            class="equal-base"
            v-html="item"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'bootstrap/scss/mixins';
@import '~/assets/scss/variables.scss';

.title {
  margin-bottom: 30px;
}

.steps {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;

  li {
    display: flex;
    flex-direction: column;
    margin-bottom: clamp(40px, 0.69vw + 37.78px, 50px);

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.item {
  &__step {
    color: $color-disabled;
    margin-bottom: 10px;
  }
}
</style>
